module.exports = {"data":{"allHomeJson":{"edges":[{"node":{"launchscreens":[{"image":"/images/uploads/av-h.jpg"}]}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 388
// module chunks = 142629428675168